import React, { useState, useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { IntlProvider } from 'react-intl'

import { blackTheme } from '../constants/theme'

import enMessages from '../intl/en.json'
import slMessages from '../intl/sl.json'

import GlobalStyles from '../styles/GlobalStyles'

import Cursor from './Cursor'
import Cookies from './Cookies'
import CoverAnimated from './CoverAnimated'

/**
 * A page layout including all global styles and theme provider.
 * Used as a wrapper in gatsby-browser and gatsby-ssr.
 * @param {ComponentProps} props
 * @param {ChildNode} props.children
 * @param {Object} props.location
 * @returns {StatelessComponent}
 */
const Page = ({ children, location, pageContext = {} }) => {
  const [isDesktop, setIsDesktop] = useState(true)

  useEffect(() => {
    setIsDesktop(window.innerWidth > 992)
  }, [isDesktop])

  const theme = blackTheme

  const locale = pageContext.locale || 'en'
  const messages = locale === 'sl' ? slMessages : enMessages

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale="en">
      <GlobalStyles />
      <ThemeProvider theme={theme}>
        {isDesktop && (
          <>
            <Cursor location={location} />
            {/* <CoverAnimated location={location} /> */}
          </>
        )}
        {children}
        <Cookies />
      </ThemeProvider>
    </IntlProvider>
  )
}

export default Page
